import { render } from "./standardized-patient-scorecard.vue?vue&type=template&id=187d8abd&scoped=true&ts=true"
import script from "./standardized-patient-scorecard.vue?vue&type=script&lang=ts"
export * from "./standardized-patient-scorecard.vue?vue&type=script&lang=ts"

import "./standardized-patient-scorecard.vue?vue&type=style&index=0&id=187d8abd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187d8abd"]])

export default __exports__